// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa240.stage.monatest.icu/auto-open-api-spec.yaml 1.6.65
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializer that is used for validating AnswerOptionConfirmation.
 * @see #/components/schemas/WorkflowAnswerOptionConfirmation - reference to schema in open-api-spec.yaml
 * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
 * @version 1.6.65
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface WorkflowAnswerOptionConfirmation {
    /**
     * Confirmation for the option is required.
     *
     */
    is_required: boolean;
    /**
     * The title of the confirmation popup.
     *
     */
    title: string;
    /**
     * The text of the confirmation popup.
     *
     */
    text: string;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for WorkflowAnswerOptionConfirmation
 */
export namespace WorkflowAnswerOptionConfirmation {
    /**
     * WorkflowAnswerOptionConfirmation Frontend Model with camelCase properties
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * Confirmation for the option is required.
         * @type boolean (`dataFormat` is missing)
         */
        isRequired: boolean;
        /**
         * The title of the confirmation popup.
         * @type string (`dataFormat` is missing)
         */
        title: string;
        /**
         * The text of the confirmation popup.
         * @type string (`dataFormat` is missing)
         */
        text: string;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * WorkflowAnswerOptionConfirmation DTO
     * Transforms WorkflowAnswerOptionConfirmation model from/to API object
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend WorkflowAnswerOptionConfirmation model */
        static toModel(obj: WorkflowAnswerOptionConfirmation): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend WorkflowAnswerOptionConfirmation model */
        static toApi(obj: Model): WorkflowAnswerOptionConfirmation {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as WorkflowAnswerOptionConfirmation;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
